export default __webpack_public_path__ + "static/media/pollopollo_logo.76b71473.svg";